import React, { useReducer } from 'react';
import UserContext from './UserContext';
import { getAndRemoveLocalStorageItem } from '../utils/clientStorage';

const defaultUserContext = {
  name: '',
  userId: '',
  personPK: '',
  image: undefined,
  jobTitle: '',
  homePageUrl: '',
  mustAnswerSecurityQuestions: false,
  UserJustAnsweredSecurityQuestion: true,
  culture: '',
  dateFormat: '',
  timeFormat: '',
  userTimeZoneId: '',
  twoLetterISOLanguageName: '',
  accessibleRcoreRoutes: new Set(),
  securedRoutes: [],
  isEmulatedUser: false,
  currentDomainId: ''
};
const UserContextProvider = (props) => {
  const [state, dispatch] = useReducer(userReducer, defaultUserContext);
  const value = { user: state, dispatch };
  return <UserContext.Provider value={value} {...props} />;
};

const userReducer = (state, action) => {
  switch (action.type) {
    case 'USER_INFO': {
      let answerSecurityQuestions = getAndRemoveLocalStorageItem('MustAnswerSecurityQuestions');
      if (typeof answerSecurityQuestions === 'undefined' || answerSecurityQuestions == null) {
        answerSecurityQuestions = action.user.mustAnswerSecurityQuestions;
      }
      return {
        ...state,
        name: action.user.name,
        userId: action.user.userId,
        personPK: action.user.personPK,
        image: action.user.image,
        jobTitle: action.user.jobTitle,
        homePageUrl: action.homePageUrl,
        mustAnswerSecurityQuestions: JSON.parse(answerSecurityQuestions),
        culture: action.user.culture,
        dateFormat: action.user.dateFormat,
        timeFormat: action.user.timeFormat,
        userTimeZoneId: action.user.userTimeZoneId,
        twoLetterISOLanguageName: action.user.twoLetterISOLanguageName,
        accessibleRcoreRoutes: action.accessibleRcoreRoutes,
        securedRoutes: action.securedRoutes,
        isEmulatedUser: action.user.isEmulatedUser,
        currentDomainId: action.user.currentDomainId
      };
    }
    case 'USER_SECURITY_QUESTIONS': {
      return {
        ...state,
        UserJustAnsweredSecurityQuestion: !action.mustAnswerSecurityQuestions,
        mustAnswerSecurityQuestions: action.mustAnswerSecurityQuestions
      };
    }
    case 'UPDATE_USER_DETAILS': {
      return {
        ...state,
        ...action.userData
      };
    }
    case 'USER_ANSWERED_SECURITY_QUESTIONS': {
      return {
        ...state,
        UserJustAnsweredSecurityQuestion: false
      };
    }
    default:
      throw new Error(`Unknon action type: ${action.type} for user update`);
  }
};

export default UserContextProvider;
